import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {LinearGradient} from 'expo-linear-gradient';
import {StyleProp, StyleSheet, ViewStyle} from 'react-native';

interface BannerProps {
  backgroundColor: string;
  iconName: string;
  iconColor?: string;
  titleText: string;
  subtitleText?: string;
  ctaText?: string;
  onClose: () => void;
  handlePress: () => void;
  closeIcon?: boolean;
  borderColor?: string;
  highlight?: number;
  textColor?: string;
  isMobileOrTab?: boolean;
  fontSize?: Number;
  customBtnStyle?: StyleProp<ViewStyle>;
  iconDimension?: number;
  iconBgColor?: string;
  color1?: string;
  color2?: string;
  paddingLeft?: number;
  customPadding?: number;
  customStyle?: number;
}

const MeetingsBanner: React.FC<BannerProps> = ({
  backgroundColor,
  iconName,
  iconColor,
  titleText = 'Get 20% off—upgrade your plan today',
  subtitleText = 'Get 20% off—upgrade your plan today',
  ctaText,
  onClose,
  handlePress,
  closeIcon,
  borderColor,
  highlight,
  textColor,
  isMobileOrTab,
  fontSize = FontSizes[12],
  customBtnStyle,
  iconDimension,
  iconBgColor,
  color1 = '#E17846',
  color2 = '#e0850f',
  paddingLeft,
  customPadding,
  customStyle,
}) => {
  return (
    <Box
      flexDirection={isMobileOrTab ? 'column' : 'row'}
      alignItems="center"
      justifyContent="space-between"
      style={styles.container}>
      <Box
        flexDirection={'row'}
        justifyContent="flex-start"
        gap={0}
        style={[
          {
            padding: isMobileOrTab ? customPadding ?? vs(20) : vs(2),
          },
        ]}
        alignItems={isMobileOrTab ? 'flex-start' : 'center'}>
        {isMobileOrTab ? (
          <Box
            alignItems="center"
            justifyContent="center"
            style={[
              styles.iconWrapper,
              {
                backgroundColor: isMobileOrTab ? 'none' : backgroundColor,
                borderColor: borderColor,
                width: customStyle ?? 20,
                height: customStyle ?? 20,
                borderWidth: customStyle ? 1.5 : 1,
              },
            ]}>
            <MaterialCommunityIcons
              name={iconName}
              size={customStyle ? 14 : 16}
              color={iconColor}
            />
          </Box>
        ) : (
          <LinearGradient
            colors={[color1, color2]}
            start={{x: 1, y: 0}}
            end={{x: 0, y: 0}}
            style={[
              styles.iconWrapper,
              {
                width: iconDimension ?? 30,
                height: iconDimension ?? 30,
                borderRadius: 17,
                marginLeft: 10,
                borderColor: borderColor,
                borderWidth: customStyle ? 1.5 : 1,
              },
            ]}>
            <MaterialCommunityIcons
              name={iconName}
              size={17}
              color={iconColor}
              style={{}}
            />
          </LinearGradient>
        )}
        <Box
          flexDirection={isMobileOrTab ? 'row' : 'column'}
          style={{
            paddingLeft: isMobileOrTab ? 5 : paddingLeft ?? 10,
            width: isMobileOrTab && '98%',
          }}>
          <CCText
            fontWeight={'semibold'}
            color={textColor}
            fontSize={fontSize}
            style={[
              styles.titleText,
              {
                paddingHorizontal: isMobileOrTab ? 5 : 0,
              },
            ]}>
            {titleText}
          </CCText>
          {subtitleText && (
            <CCText
              color={textColor}
              fontWeight={400}
              fontSize={fontSize ? FontSizes[11] : FontSizes[10]}
              style={{
                paddingHorizontal: customStyle ? 0 : 5,
              }}>
              {subtitleText}
            </CCText>
          )}
        </Box>
      </Box>
      {!isMobileOrTab && (
        <Box
          flexDirection="row"
          alignItems="center"
          gap={8}
          style={styles.rtbox}>
          {ctaText && (
            <CCButton
              contentContainerStyle={[styles.ctaButtonContent, customBtnStyle]}
              onPress={handlePress}
              style={[
                styles.ctaButton,
                {
                  backgroundColor: highlight
                    ? CCColors.Primary.Default
                    : CCColors.CCTableBg,
                },
              ]}>
              <CCText fontWeight={500} fontSize={FontSizes[12]}>
                {ctaText}
              </CCText>
            </CCButton>
          )}
          {closeIcon && (
            <Box
              onPress={onClose}
              alignItems="center"
              justifyContent="center"
              style={styles.closeButton}>
              <MaterialCommunityIcons name="close" size={14} />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingRight: 5,
    borderRadius: 8,
    overflow: 'hidden',
  },
  iconWrapper: {
    width: 25,
    height: 25,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  titleText: {
    paddingHorizontal: 20,
    maxWidth: 900,
    flexWrap: 'wrap',
  },
  subtitleText: {
    paddingHorizontal: 5,
  },
  ctaButtonContent: {
    paddingHorizontal: 12,
    paddingVertical: 5,
  },
  ctaButton: {
    marginHorizontal: 8,
  },
  closeButton: {
    width: 25,
    height: 25,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CCColors.CCTableBg,
  },
  rtbox: {
    marginRight: 5,
  },
  text: {
    maxWidth: '90%',
  },
});

export default MeetingsBanner;
